import React, { lazy } from 'react';
import { ADMIN_ROUTE, ORGANIZATION_ROUTE, PRIVATE_ROUTE, PUBLIC_ROUTE } from '../constants/common';
import EditorSpace from '../components/EditorSpace/EditorSpace';

const AccountInformationSettings = lazy(() => import('./../pages/Settings/AccountInformationSettings'));
const ManagePermissionSettings = lazy(() => import('./../pages/Settings/ManagePermissionSettings'));
const ManageRequests = lazy(() => import('./../pages/Settings/ManageRequests'));
const IntegrationsPage = lazy(() => import('../pages/IntegrationsPage/IntegrationsPage'));
const BitbucketPage = lazy(() => import('../pages/BitbucketPage/BitbucketPage'));
// const EditorSpace = lazy(() => import('../components/EditorSpace/EditorSpace'));
const UserSpace = lazy(() => import('../components/UserSpace/UserSpace'));
const AdminContent = lazy(() => import('../Layout/Admin/AdminContent'));
const ResponsiveWorkspaceTree = lazy(() => import('../pages/Mobile'));
const HomePage = lazy(() => import('./../pages/Home/HomePage'));
const Login = lazy(() => import('../pages/Login/LoginPage'));
const TrashPage = lazy(() => import('./../pages/Trash'));
const OnedocAiPage = lazy(() => import('./../pages/Ai'));
const NestedFolderMenu = lazy(() => import('../pages/MobileFolderStructure/NestedFolderMenu'));
const Search = lazy(() => import('../pages/Search'));
const StarredFile = lazy(() => import('../pages/StarredFile'));
const ApiPage = lazy(() => import('../pages/ApiPage'));
const ManageTemplates = lazy(() => import('../pages/Settings/ManageTemplates'));
const Workspace = lazy(() => import('../pages/Workspace/Workspace'));
const FolderPage = lazy(() => import('../pages/FolderPage/FolderPage'));
const AnnouncementPage = lazy(() => import('../pages/Announcement/Announcement'));
const AIFeedbackAnalysis = lazy(() => import('../pages/Settings/AIConversationAnalytics'));
const Profile = lazy(() => import('../components/Profile/Profile'));
const RequestHandler = lazy(() => import('../pages/HandleRequestPage'));
const OneDocSitesPage = lazy(() => import('../pages/OneDocSites'));
const SiteSettingsPage = lazy(() => import('../pages/SiteSettings/SiteSettingsPage'));

export const ROUTELIST = [
  {
    name: 'settings',
    path: '/settings',
    routeType: ADMIN_ROUTE,
    component: AdminContent,
    subRoutes: [
      { name: 'account-information', path: 'account-information', component: AccountInformationSettings },
      { name: 'manage-permission', path: 'manage-permission', component: ManagePermissionSettings },
      { name: 'manege-templates', path: 'manage-templates', component: ManageTemplates },
      { name: 'manage-requests', path: 'manage-requests', component: ManageRequests },
      { name: 'ai-conversation-analytics', path: 'ai-conversation-analytics', component: AIFeedbackAnalysis },
      { name: 'manage-profile', path: 'manage-profile', component: Profile },
    ],
  },
  { name: 'home', path: '/home', routeType: PRIVATE_ROUTE, component: HomePage },
  { name: 'chat-with-id', path: '/chat/:id', routeType: PRIVATE_ROUTE, component: OnedocAiPage },
  {
    name: 'chat',
    path: '/chat',
    routeType: PRIVATE_ROUTE,
    component: OnedocAiPage,
    subRoutes: [
      { name: 'chat-id', path: ':id', component: OnedocAiPage },
      { name: 'new-chat', path: '', component: OnedocAiPage },
    ],
  },
  {
    name: 'space',
    path: '/spaces/:spaceId',
    routeType: PRIVATE_ROUTE,
    component: Workspace,
  },
  {
    name: 'folder-page',
    path: '/spaces/:spaceId/folder/:folderId',
    routeType: PRIVATE_ROUTE,
    component: FolderPage,
  },
  {
    name: 'space',
    path: '/spaces/:spaceId',
    routeType: PRIVATE_ROUTE,
    component: UserSpace,
    subRoutes: [
      { name: 'file-edit-page', path: 'pages/:pageId/edit', component: EditorSpace },
      { name: 'file-page', path: 'pages/:pageId', component: EditorSpace },

      // { name: 'folder-edit-page', path: 'page/:folderId/:pageId/edit', component: EditorSpace },
      // { name: 'orphan-file-edit', path: 'page/:folderId/edit', component: EditorSpace },
      // { name: 'folder-spec-page-edit', path: 'page/:folderId/spec/:pageId/edit', component: EditorSpace },
      // { name: 'spec-page-edit', path: 'page/spec/:folderId/edit', component: EditorSpace },
      // { name: 'folder-spec-page', path: 'page/:folderId/spec/:pageId', component: EditorSpace },
      // { name: 'folder-page', path: 'page/:folderId/:pageId', component: EditorSpace },
      // { name: 'spec-page', path: 'page/spec/:pageId', component: EditorSpace },
      // { name: 'page', path: 'page/:pageId', component: EditorSpace },
    ],
  },
  { name: 'space-trash', path: '/spaces/:spaceId/trash', routeType: PRIVATE_ROUTE, component: TrashPage },
  { name: 'login', path: '/login', routeType: PUBLIC_ROUTE, component: Login },
  // { name: 'organization', path: '/organization', routeType: ORGANIZATION_ROUTE, component: OrganizationPage },
  { name: 'workspacetree', path: '/workspacetree', routeType: PRIVATE_ROUTE, component: ResponsiveWorkspaceTree },
  { name: 'integrations', path: '/integrations', routeType: PRIVATE_ROUTE, component: IntegrationsPage },
  { name: 'bitbucket', path: '/bitbucket/auth', routeType: PRIVATE_ROUTE, component: BitbucketPage },
  { name: 'folderlist', path: '/folderlist', routeType: PRIVATE_ROUTE, component: NestedFolderMenu },
  { name: 'search', path: '/search', routeType: PRIVATE_ROUTE, component: Search },
  { name: 'starred', path: '/starred', routeType: PRIVATE_ROUTE, component: StarredFile },
  { name: 'api', path: '/api', routeType: PRIVATE_ROUTE, component: ApiPage },
  { name: 'onedoc-sites', path: '/onedoc-sites', routeType: PRIVATE_ROUTE, component: OneDocSitesPage },
  { name: 'announcement', path: '/announcement', routeType: PRIVATE_ROUTE, component: AnnouncementPage },
  { name: 'handle-request', path: '/handle-request', routeType: ORGANIZATION_ROUTE, component: RequestHandler },
  { name: 'site-settings', path: '/site-settings', routeType: PRIVATE_ROUTE, component: SiteSettingsPage },
  {
    name: 'site-settings-with-id',
    path: '/site-settings/:siteId',
    routeType: PRIVATE_ROUTE,
    component: SiteSettingsPage,
  },
];
